var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.status)?_c('section',[_c('div',{staticClass:"copyright"},[_vm._v(" "+_vm._s(new Date().getFullYear())+" "),_c('v-icon',{staticClass:"mx-1"},[_vm._v(" mdi-copyright ")]),_c('strong',[_vm._v("EV Drive")])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }